module.exports = __webpack_public_path__ + "static/media/2019vilas.72110603.jpg";